/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-favorite': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.031 3.75c.92 0 1.8.369 2.444 1.025a3.563 3.563 0 010 5L10 16.331 3.525 9.775a3.562 3.562 0 010-5 3.425 3.425 0 014.887 0L10 6.4l1.581-1.613a3.4 3.4 0 012.45-1.037zm0-1.25a4.669 4.669 0 00-3.337 1.4L10 4.6l-.694-.7a4.681 4.681 0 00-6.675 0 4.825 4.825 0 000 6.762L10 18.125l7.369-7.463a4.825 4.825 0 000-6.762 4.681 4.681 0 00-3.338-1.4z"/>'
  }
})
